import axios from 'axios';
import { isPublicTagHost } from './publicTagHost';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const NOTES_API_BASE = `${BACKEND_URL}/api`;

// Dedicated client for the Notes module. Sends the Notes token when present;
// otherwise falls back to the Inventique token so a signed-in Super Admin can
// drive Notes via the module toggle without a second login.
export const notesApi = axios.create({ baseURL: NOTES_API_BASE });

notesApi.interceptors.request.use((config) => {
  const nt = localStorage.getItem('notes_token');
  const it = localStorage.getItem('inv_token');
  // On the tag domain only a Notes token is accepted — never the ERP token.
  const token = isPublicTagHost() ? nt : (nt || it);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const tagCompany = isPublicTagHost() ? localStorage.getItem('tagws_company') : null;
  if (tagCompany) config.headers['X-Tag-Company'] = tagCompany;
  return config;
});

notesApi.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err.response?.status;
    if (isPublicTagHost()) {
      const detail = err.response?.data?.detail;
      if (status === 401 && detail === 'portal_locked_session_ended') { window.dispatchEvent(new Event('tagws-session-ended')); return Promise.reject(err); }
      if (status === 423) window.dispatchEvent(new Event('tagws-locked'));
    }
    if (status === 401) {
      const path = window.location.pathname;
      const nt = localStorage.getItem('notes_token');
      // Only drop the token the failed request actually sent (a fresh login may have replaced it).
      const hasNotes = !!nt && (err.config?.headers?.Authorization || '') === `Bearer ${nt}`;
      if (hasNotes) {
        // Notes session expired → back to the unified login.
        localStorage.removeItem('notes_token');
        localStorage.removeItem('notes_user');
        if (path.startsWith('/notes') && path !== '/notes/login') {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(err);
  }
);
